module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar attributes = model.nrOfElementsAttributes || {}\n%>\n<table>\n<tbody>\n<tr>\n<td class=\"name\"><%= storage.__(config.translationPrefix + '.summary.nrOfElements') %>:</td>\n<td class=\"value\"><%= attributes.nrOfVisibleElements || 0 %></td>\n</tr>\n<tr>\n<td class=\"name\"><%= storage.__(config.translationPrefix + '.summary.nrOfMatchingElements') %>:</td>\n<td class=\"value\"><%= attributes.nrOfMatchingElements || 0 %></td>\n</tr>\n<tr class=\"row\">\n<td class=\"name\"><%= storage.__(config.translationPrefix + '.summary.nrOfAllElements') %>:</td>\n<td class=\"value\"><%= (attributes.nrOfElements || 0) %></td>\n</tr>\n</tbody>\n</table>"
  , __filename = "components/templates/ttgShop/coupons/summary.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var attributes = model.nrOfElementsAttributes || {}

    ; __line = 3
    ; __append("\n<table>\n<tbody>\n<tr>\n<td class=\"name\">")
    ; __line = 7
    ; __append(escapeFn( storage.__(config.translationPrefix + '.summary.nrOfElements') ))
    ; __append(":</td>\n<td class=\"value\">")
    ; __line = 8
    ; __append(escapeFn( attributes.nrOfVisibleElements || 0 ))
    ; __append("</td>\n</tr>\n<tr>\n<td class=\"name\">")
    ; __line = 11
    ; __append(escapeFn( storage.__(config.translationPrefix + '.summary.nrOfMatchingElements') ))
    ; __append(":</td>\n<td class=\"value\">")
    ; __line = 12
    ; __append(escapeFn( attributes.nrOfMatchingElements || 0 ))
    ; __append("</td>\n</tr>\n<tr class=\"row\">\n<td class=\"name\">")
    ; __line = 15
    ; __append(escapeFn( storage.__(config.translationPrefix + '.summary.nrOfAllElements') ))
    ; __append(":</td>\n<td class=\"value\">")
    ; __line = 16
    ; __append(escapeFn( (attributes.nrOfElements || 0) ))
    ; __append("</td>\n</tr>\n</tbody>\n</table>")
    ; __line = 19
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/ttgShop/coupons/summary.ejs

}